<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jNULvT/tc-custom/9781504067799.jpg?1721100062668" alt="This image is the cover for the book Copper Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Copper Moon
      </h1>
      <p class="bookDescription body article font2">
        <b>A novel of romance, suspense, and supernatural terror in a small Texas town by the <i>New York Times</i>–bestselling author of the Stillhouse Lake series.</b><br/>  <br/> Abby Rhodes is a music teacher in small-town Texas, but she’s about to journey to places she never imagined before. When a gorgeous man appears at her door and touches her hand, Abby’s world is changed forever. Her heart is overwhelmed by him, but her mind is being taken over by a dark supernatural force she can’t understand—a force that makes her question the true nature of the man who has so enchanted her. As she fights to regain control of her own soul, Abby may be forced to choose between love and survival . . .<br/>  <br/><b>Praise for Rachel Caine</b><br/>  <br/> “Rapid-fire . . . powerful.” —<i>Publishers Weekly</i> on<i> Stillhouse Lake</i><br/>  <br/> “Absorbing suspense . . . gripping, original.” —<i>Kirkus Reviews </i>on <i>Last Breath</i><br/>  <br/> “Exciting, fast-paced adventure.” —<i>Library Journal </i>on <i>Paper and Fire</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Caine
      </h2>
      
      <p class="authorDescription body article">Rachel Caine (1962&ndash;2020) was the <I>New York Times</I>&ndash;,<I> USA Today</I>&ndash;, and #1 <I>Wall Street Journal&ndash;</I>bestselling author of more than fifty books across multiple genres, from adult thriller to urban fantasy/science fiction, as well as works for young adults. With millions of copies sold, she was a frequent guest at conventions in the United States and around the world. Her popular book series include the Morganville Vampires novels, the Great Library series, and the #1-bestselling Stillhouse Lake books. Caine lost her fight with a rare and aggressive cancer, soft tissue sarcoma, in November of 2020.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a9bddf8